import BaseComponentController from "../../controllers/design_system/components/base_component_controller"

export default class extends BaseComponentController {
  static values = {
    searchUrl: String,
    createUrl: String,
    imageContentId: String,
    sourceImageId: String,
    sourceImageType: String,
    aspectRatios: Array,
    ownerType: String,
    ownerId: String,
    ownerAssociation: String,
    placeholderUrl: String,
    suggestUrl: String,
    showAltInput: Boolean
  }

  static targets = ["componentBody"]

  get editUrl() {
    if (!this.imageContentIdValue) return null
    return this.createUrlValue + "/" + this.imageContentIdValue + "/edit"
  }

  get altDescriptionUrl() {
    if (!this.imageContentIdValue) return null
    return this.createUrlValue + "/" + this.imageContentIdValue + "/alt_description"
  }

  get destroyUrl() {
    if (!this.imageContentIdValue) return null
    return this.createUrlValue + "/" + this.imageContentIdValue
  }

  get revertSuggestionsUrl() {
    if (!this.imageContentIdValue) return null
    return this.createUrlValue + "/" + this.imageContentIdValue + "/revert_suggestions"
  }

  get isAi() {
    return !!this.suggestUrlValue
  }

  openAi(event) {
    if (!this.suggestUrlValue) return

    $(event.currentTarget).tooltip("hide")

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const $thumb = $(this.componentBodyTarget).find(".thumb")
    appCustomerSpace.Loader().start({ $container: $thumb, options: { text: false } })

    fetch(this.suggestUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        owner_type: this.ownerTypeValue,
        owner_id: this.ownerIdValue,
        owner_association: this.ownerAssociationValue,
        image_content_id: this.imageContentIdValue,
        ai: this.isAi,
        aspect_ratios: this.aspectRatiosValue.join(","),
        show_alt_input: this.showAltInputValue
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          this.handleImageSelected(data.image_content, data.component_body_html)
          this._showUndoButton()
        } else {
          appCustomerSpace.Loader().stop({ $container: $thumb })
          if (data.error) {
            new PNotify({ icon: 'icon-info22', title: data.error, type: 'info', delay: 3000 })
          }
        }
      })
      .catch(() => appCustomerSpace.Loader().stop({ $container: $thumb }))
  }

  revertAi(event) {
    if (!this.imageContentIdValue) return

    $(event.currentTarget).tooltip("hide")

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const $thumb = $(this.componentBodyTarget).find(".thumb")
    appCustomerSpace.Loader().start({ $container: $thumb, options: { text: false } })

    fetch(this.revertSuggestionsUrl, {
      method: "DELETE",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        ai: this.isAi,
        aspect_ratios: this.aspectRatiosValue.join(","),
        show_alt_input: this.showAltInputValue
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          this.resetComponent(data)
        } else {
          appCustomerSpace.Loader().stop({ $container: $thumb })
        }
      })
      .catch(() => appCustomerSpace.Loader().stop({ $container: $thumb }))
  }

  selectSuggestion(event) {
    const radio = event.currentTarget
    const sourceImageId = radio.value
    const sourceImageType = radio.dataset.sourceImageType
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    this.element.querySelectorAll(".ai-suggestions .suggestion").forEach(el => el.classList.remove("checked"))
    radio.closest(".suggestion").classList.add("checked")

    const $thumb = $(this.componentBodyTarget).find(".thumb")
    appCustomerSpace.Loader().start({ $container: $thumb, options: { text: false } })

    fetch(this.createUrlValue, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        source_image_id: sourceImageId,
        source_image_type: sourceImageType,
        owner_type: this.ownerTypeValue,
        owner_id: this.ownerIdValue,
        owner_association: this.ownerAssociationValue,
        from_suggestion: "1",
        ai: this.isAi,
        aspect_ratios: this.aspectRatiosValue.join(","),
        show_alt_input: this.showAltInputValue
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          this.handleImageSelected(data.image_content, data.component_body_html)
          this._showUndoButton()
        } else {
          appCustomerSpace.Loader().stop({ $container: $thumb })
        }
      })
      .catch(error => {
        appCustomerSpace.Loader().stop({ $container: $thumb })
        console.error("selectSuggestion failed:", error)
      })
  }

  openSearch() {
    const url = new URL(this.searchUrlValue, window.location.origin)

    fetch(url, {
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          const $html = $(data.html)
          $html.data("stimulus-controller", this)
          appCustomerSpace.Modal.mountCurrentModal($html)
          if (appCustomerSpace.currentModal) {
            appCustomerSpace.currentModal.open({ modalLevel: 1 })
          }
        }
      })
  }

  openEdit() {
    if (!this.imageContentIdValue) return

    const url = new URL(this.editUrl, window.location.origin)
    url.searchParams.set("aspect_ratios", this.aspectRatiosValue.join(","))

    fetch(url, {
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          const $html = $(data.html)
          $html.data("stimulus-controller", this)
          appCustomerSpace.Modal.mountCurrentModal($html)
          if (appCustomerSpace.currentModal) {
            appCustomerSpace.currentModal.open({ modalLevel: 1 })
          }
        }
      })
  }

  openAltDescription() {
    if (!this.imageContentIdValue) return

    const url = new URL(this.altDescriptionUrl, window.location.origin)

    fetch(url, {
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          const $html = $(data.html)
          $html.data("stimulus-controller", this)
          appCustomerSpace.Modal.mountCurrentModal($html)
          if (appCustomerSpace.currentModal) {
            appCustomerSpace.currentModal.open({ modalLevel: 1 })
          }
        }
      })
  }

  changeRatio(event) {
    if (!this.imageContentIdValue) return

    const ratio = event.params.ratio
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const updateUrl = this.createUrlValue + "/" + this.imageContentIdValue

    const $thumb = $(this.componentBodyTarget).find(".thumb")
    appCustomerSpace.Loader().start({ $container: $thumb, options: { text: false } })

    fetch(updateUrl, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        aspect_ratio: ratio,
        ai: this.isAi,
        aspect_ratios: this.aspectRatiosValue.join(","),
        show_alt_input: this.showAltInputValue
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          this.handleImageEdited(data.image_content, data.component_body_html)
        } else {
          appCustomerSpace.Loader().stop({ $container: $thumb })
        }
      })
      .catch(error => {
        appCustomerSpace.Loader().stop({ $container: $thumb })
        console.error("changeRatio failed:", error)
      })
  }

  deleteImage(event) {
    if (!this.imageContentIdValue) return

    $(event.currentTarget).tooltip("hide")

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch(this.destroyUrl, {
      method: "DELETE",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        ai: this.isAi,
        aspect_ratios: this.aspectRatiosValue.join(","),
        show_alt_input: this.showAltInputValue
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.response) {
          this.resetComponent(data)
        }
      })
  }

  handleImageSelected(imageContent, componentBodyHtml) {
    this.imageContentIdValue = String(imageContent.id)
    this.sourceImageIdValue = String(imageContent.source_image_id)
    this.sourceImageTypeValue = String(imageContent.source_image_type)

    this._replaceComponentBody(componentBodyHtml)

    this.dispatchEvent({
      action: "updated",
      options: {
        detail: {
          imageContentId: imageContent.id,
          sourceImageId: imageContent.source_image_id,
          mediumUrl: imageContent.medium_url
        }
      }
    })
  }

  handleImageEdited(imageContent, componentBodyHtml) {
    this._replaceComponentBody(componentBodyHtml)

    this.dispatchEvent({
      action: "updated",
      options: {
        detail: {
          imageContentId: imageContent.id,
          sourceImageId: imageContent.source_image_id,
          mediumUrl: imageContent.medium_url
        }
      }
    })
  }

  resetComponent(data) {
    this.imageContentIdValue = ""
    this.sourceImageIdValue = ""
    this.sourceImageTypeValue = ""

    this._replaceComponentBody(data.component_body_html)

    this.dispatchEvent({ action: "deleted", options: { detail: { imageContentId: this.imageContentIdValue } } })
  }

  _showUndoButton() {
    const wrapper = this.componentBodyTarget.querySelector(".ai-wrapper")
    if (!wrapper) return

    const magicBtn = wrapper.querySelector('[data-action*="openAi"]')
    const undoBtn = wrapper.querySelector('[data-action*="revertAi"]')

    if (magicBtn) magicBtn.style.display = "none"
    if (undoBtn) undoBtn.style.display = ""
  }

  _replaceComponentBody(html) {
    if (html && this.hasComponentBodyTarget) {
      $(this.componentBodyTarget).find('[data-popup="tooltip"]').tooltip("destroy")
      this.componentBodyTarget.innerHTML = html
      appCustomerSpace.LimitlessPlugins.Tooltip.init($(this.componentBodyTarget))
    }
  }
}
